// generated from 12_700 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hardBounceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("hard_bounce_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 4_017 (31.63%), defined 8_683 (68.37%)
  raw_value: z
    .union([
      // boolean samples: 8_682 (99.99%)
      // true 906 (10.44%), false 7_776 (89.56%)
      z.boolean(),
      // string samples: 1 (0.01%)
      z.literal(""),
    ])
    .optional(),
  value: z.union([
    // boolean samples: 12_699 (99.99%)
    // true 1_096 (8.63%), false 11_603 (91.37%)
    z.boolean(),
    // string samples: 1 (0.01%)
    z.literal(""),
  ]),
  varies_by_app_group: z.literal(false),
});
